/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";

import { Modal, Form, message, Select, Input } from "antd";

import useUsers from "../hooks/useUsers.js";

import FetchSelect from "../ui-components/FetchSelect.jsx";
import useBuses from "../hooks/useBuses.js";
import useHotels from "../hooks/useHotels.js";

function ExcursionBusesFormModal({
  onCreate,
  selectedExcursion,
  selectedBus,
  isOpen,
  onClose,
  busToEdit,
}) {
  const { getUsers } = useUsers();
  const { hotels, getHotels } = useHotels();
  const { getBusExcursion, busExcursions, loading, createBus, updateBus } =
    useBuses();

  const [form] = Form.useForm();

  const [isFormValid, setIsFormValid] = useState(false);

  useEffect(() => {
    if (!selectedExcursion) return;

    getBusExcursion({ excursion_type: selectedExcursion.excursionType.id });
    getHotels({
      scheduled_excursion_id: selectedExcursion.id,
    });
  }, [selectedExcursion]);

  useEffect(() => {
    if (busToEdit) {
      form.setFieldsValue({
        guide: busToEdit.guide.id,
        busExcursion: busToEdit.busExcursion.id,
        departureHotel: busToEdit.departureHotel?.id,
        observation: busToEdit.observation,
      });
    }
  }, [busToEdit]);

  async function submitForm() {
    try {
      const values = await form.validateFields();

      const finalValues = {
        ...values,
        guide: values.guide.value,
        scheduledExcursion: selectedExcursion.id,
      };

      busToEdit && (finalValues.id = busToEdit.id);

      busToEdit ? await updateBus(finalValues) : await createBus(finalValues);
    } catch (error) {
      message.warning("Formulario invalido");
    }

    onClose();
  }

  function handleFormChange() {
    setTimeout(() => {
      form
        .validateFields({ validateOnly: true })
        .then(() => {
          setIsFormValid(true);
        })
        .catch(() => {
          setIsFormValid(false);
        });
    }, 300);
  }

  return (
    <>
      <Modal
        open={isOpen}
        onOk={submitForm}
        okText={busToEdit ? "Editar Micro" : "Crear Micro"}
        okButtonProps={{ disabled: !isFormValid }}
        confirmLoading={loading.post}
        onCancel={() => {
          onClose();
        }}
        afterClose={() => {
          form.resetFields();
        }}
        zIndex={1050}
      >
        <Form form={form} layout="vertical" onFieldsChange={handleFormChange}>
          <Form.Item
            name="guide"
            label="Guía"
            rules={[{ required: true, message: "Seleccione un guía" }]}
          >
            <FetchSelect
              placeholder="Seleccione un Guía"
              searchParam={"name"}
              elementFetcher={getUsers}
              labelShow={(user) => {
                if (!user) return "";

                return `${user.firstName} ${user.lastName}`;
              }}
              fieldNames={{ label: "", value: "id" }}
              extraParams={{
                user_type: "GUIDE",
              }}
            />
          </Form.Item>
          <Form.Item
            label="Bus de excursión"
            name="busExcursion"
            rules={[{ required: true, message: "Please enter the company" }]}
          >
            <Select
              options={busExcursions.results}
              fieldNames={{ label: "name", value: "id" }}
              labelRender={(label) => {
                if (!label || !busExcursions?.results) return "";

                const bus = busExcursions.results.find(
                  (bus) => bus.id === label.value
                );

                return bus.bus.busSelectorName;
              }}
              optionRender={(option) => {
                if (!option || !busExcursions?.results) return "";

                const bus = busExcursions.results.find(
                  (bus) => bus.id === option.value
                );

                return bus.bus.busSelectorName;
              }}
              loading={!busExcursions}
            />
          </Form.Item>
          <Form.Item
            name="departureHotel"
            label="Hotel de salida"
            rules={[
              { required: false, message: "Please enter the phone number" },
            ]}
          >
            <Select
              options={hotels.results}
              fieldNames={{ label: "name", value: "id" }}
              loading={!hotels}
            />
          </Form.Item>
          <Form.Item
            name="observation"
            label="Observación"
            rules={[
              { required: false, message: "Ingrese una observación" },
            ]}
          >
            <Input.TextArea
              rows={3}
              placeholder="Observación específica del micro para esta asignación"
            />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
}

export default ExcursionBusesFormModal;
